<template>
  <input type="password"
    :placeholder="placeholder"
    :name="name"
    @input="updateValue"
  >
</template>

<script>
export default {
  props: {
    placeholder: {
      type: String,
      required: false,
    },
    name: {
      type: String,
      required: false
    },
  },
  methods: {
    updateValue: function(e) {
      this.$emit("input", e.target.value);
    }
  }
}
</script>
